import i18next from "i18next";
import '@/locale';

const errorCodes:{
  [key in number]: string
} = {
  501: i18next.t('apiError.error1_1'),
  502: i18next.t('apiError.error1_2'),
  503: i18next.t('apiError.error1_3'),
  504: i18next.t('apiError.error1_4'),
  505: i18next.t('apiError.error1_5'),

  69001: i18next.t('apiError.error1'),
  69021: i18next.t('apiError.error66'),
  69005: i18next.t('apiError.error2'),
  69006: i18next.t('apiError.error3'),
  69008: i18next.t('apiError.error4'),
  69013: i18next.t('apiError.error5'),
  69015: i18next.t('apiError.error6'),
  69017: i18next.t('apiError.error7'),
  
  69301: i18next.t('apiError.error8'),
  69302: i18next.t('apiError.error9'),
  69303: i18next.t('apiError.error10'),
  69304: i18next.t('apiError.error11'),
  69305: i18next.t('apiError.error12'),
  
  70201: i18next.t('apiError.error13'),
  70203: i18next.t('apiError.error14'),
  70204: i18next.t('apiError.error15'),
  70205: i18next.t('apiError.error16'),
  70206: i18next.t('apiError.error17'),
  70207: i18next.t('apiError.error17'),
  70208: i18next.t('apiError.error18'),
  70209: i18next.t('apiError.error19'),
  
  70301: i18next.t('apiError.error20'),
  70302: i18next.t('apiError.error21'),
  70303: i18next.t('apiError.error22'),
  
  70401: i18next.t('apiError.error23'),
  
  70501: i18next.t('apiError.error24'),
  
  70601: i18next.t('apiError.error25'),
  70602: i18next.t('apiError.error26'),
  
  70701: i18next.t('apiError.error27'),
  70702: i18next.t('apiError.error28'),
  70703: i18next.t('apiError.error29'),
  
  70801: i18next.t('apiError.error30'),
  70802: i18next.t('apiError.error31'),
  70803: i18next.t('apiError.error32'),
  70804: i18next.t('apiError.error33'),

  70603: i18next.t('apiError.error34'),

  10010: i18next.t('apiError.error35'),
  10011: i18next.t('apiError.error36'),
  
  70604: i18next.t('apiError.error37'),
  70812: i18next.t('apiError.error38'),
  70255: i18next.t('apiError.error16'),

  73007: i18next.t('apiError.error39'),
  73431: i18next.t('apiError.error40'),
  73432: i18next.t('apiError.error41'),
  73433: i18next.t('apiError.error42'),
  73434: i18next.t('apiError.error43'),
  73435: i18next.t('apiError.error44'),

  70902: i18next.t('apiError.error45'),
  70903: i18next.t('apiError.error46'),
  70904: i18next.t('apiError.error47'),

  74201: i18next.t('apiError.error48'),
  74202: i18next.t('apiError.error49'),
  74203: i18next.t('apiError.error50'),
  74204: i18next.t('apiError.error51'),
  74205: i18next.t('apiError.error52'),
  74206: i18next.t('apiError.error53'),
  74207: i18next.t('apiError.error54'),
  74208: i18next.t('apiError.error55'),
  74209: i18next.t('apiError.error56'),
  74210: i18next.t('apiError.error57'),
  74211: i18next.t('apiError.error58'),
  74212: i18next.t('apiError.error59'),
  74213: i18next.t('apiError.error60'),
  74214: i18next.t('apiError.error61'),
  74215: i18next.t('apiError.error62'),
  74216: i18next.t('apiError.error63'),
  74217: i18next.t('apiError.error64'),
  74218: i18next.t('apiError.error65'),
}

export default errorCodes;
